// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_js-0";
export var buttonContainer = "_js-3";
export var cancelButton = "_js-4";
export var headerSection = "_js-6";
export var headerTitle = "_js-9";
export var messageSideLeft = "_js-1";
export var messageSideRight = "_js-2";
export var orderNumberContainer = "_js-7";
export var orderNumberLabel = "_js-8";
export var submitButton = "_js-5";